/* Lycan Forge theme scripts — no dependencies */
(function () {
  'use strict';
  var T = window.LycanTheme || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Header: solid glass once the page scrolls */
  var headerWrap = $('[data-header]');
  if (headerWrap) {
    var onScroll = function () { headerWrap.classList.toggle('is-stuck', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Mobile drawer */
  var drawer = $('[data-drawer]');
  var lastFocus = null;
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { lastFocus = document.activeElement; var f = $('[data-drawer-close]', drawer); if (f) f.focus(); }
    else if (lastFocus) { lastFocus.focus(); }
  }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });

  /* Search overlay */
  var search = $('[data-search]');
  function setSearch(open) {
    if (!search) return;
    search.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var i = $('input', search); if (i) setTimeout(function () { i.focus(); }, 30); }
  }
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); setSearch(true); }); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { setSearch(false); }); });
  if (search) search.addEventListener('click', function (e) { if (e.target === search) setSearch(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (search && !search.hidden) setSearch(false);
    if (drawer && drawer.classList.contains('is-open')) setDrawer(false);
  });

  /* Reveal on scroll */
  var revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Tabs */
  $$('[data-tabs]').forEach(function (root) {
    var btns = $$('[role="tab"]', root);
    var panels = $$('[role="tabpanel"]', root);
    function select(i, focus) {
      btns.forEach(function (b, n) { b.setAttribute('aria-selected', n === i ? 'true' : 'false'); b.tabIndex = n === i ? 0 : -1; });
      panels.forEach(function (p, n) { p.hidden = n !== i; });
      var url = $('[data-frame-url]', root);
      if (url && btns[i]) url.textContent = btns[i].getAttribute('data-url') || url.textContent;
      if (focus) btns[i].focus();
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') select((i + 1) % btns.length, true);
        if (e.key === 'ArrowLeft') select((i - 1 + btns.length) % btns.length, true);
      });
    });
  });

  /* Toast */
  var toast = $('[data-toast]');
  var toastTimer = null;
  function showToast(msg) {
    if (!toast) return;
    $('[data-toast-text]', toast).textContent = msg;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); setTimeout(function () { toast.hidden = true; }, 400); }, 4200);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var wrap = b.closest('.qty');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + (b.getAttribute('data-qty') === 'plus' ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: submit when a quantity changes */
  $$('[data-cart-form] .qty input').forEach(function (input) {
    var t = null;
    input.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () { input.form.submit(); }, 450);
    });
  });

  /* Collection sort / filter: submit on change */
  $$('[data-autosubmit]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      form.submit();
    });
  });

  /* Product form */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('script[data-product-json]', root);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('form.product-form', root);
    var idInput = form && $('input[name="id"]', form);
    var addBtn = form && $('[data-add]', form);
    var addLabel = addBtn && $('[data-add-label]', addBtn);
    var msg = $('[data-form-msg]', root);
    var money = function (cents) {
      var fmt = root.getAttribute('data-money-format') || '${{amount}}';
      var v = (cents / 100).toFixed(2);
      var parts = v.split('.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (k === 'amount_with_comma_separator') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        return withCommas;
      });
    };

    function currentOptions() {
      return $$('fieldset[data-option]', root).map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function markAvailability(opts) {
      $$('fieldset[data-option]', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function goToMedia(mediaId) {
      if (!mediaId) return;
      var slide = $('[data-media-id="' + mediaId + '"]', root);
      if (slide) showSlide($$('[data-slide]', root).indexOf(slide));
    }

    function onChange() {
      var opts = currentOptions();
      $$('fieldset[data-option]', root).forEach(function (fs, i) {
        var lbl = $('[data-selected]', fs); if (lbl) lbl.textContent = opts[i] || '';
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addLabel.textContent = T.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
      $$('[data-price-now]', root).forEach(function (el) { el.textContent = money(v.price); });
      var on = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-price-was]', root).forEach(function (el) { el.hidden = !on; el.textContent = on ? money(v.compare_at_price) : ''; });
      $$('[data-price-save]', root).forEach(function (el) {
        el.hidden = !on;
        if (on) el.textContent = el.textContent.replace(/\d+%/, Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
      });
      if (v.featured_media) goToMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    $$('fieldset[data-option] input', root).forEach(function (inp) { inp.addEventListener('change', onChange); });
    if ($$('fieldset[data-option]', root).length) markAvailability(currentOptions());

    /* Gallery */
    var slides = $$('[data-slide]', root);
    var thumbs = $$('[data-thumb]', root);
    var active = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function showSlide(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === i);
        if (n !== i) { var vid = $('video', s); if (vid) vid.pause(); }
      });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      active = i;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showSlide(i); }); });
    $$('[data-gal-prev]', root).forEach(function (b) { b.addEventListener('click', function () { showSlide(active - 1); }); });
    $$('[data-gal-next]', root).forEach(function (b) { b.addEventListener('click', function () { showSlide(active + 1); }); });
    var main = $('.gallery__main', root);
    if (main) {
      var sx = 0;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) showSlide(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* Add to cart via AJAX, with a normal form post as the fallback */
    if (form && window.fetch) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true'); }
        if (msg) msg.hidden = true;
        fetch(T.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.d.description || res.d.message || T.strings.error);
            showToast(T.strings.added);
            return fetch(T.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) { if (cart) updateCartCount(cart.item_count); })
          .catch(function (err) { if (msg) { msg.textContent = err.message; msg.hidden = false; } })
          .finally(function () { if (addBtn) { addBtn.disabled = false; addBtn.removeAttribute('aria-busy'); } onChange(); });
      });
    }

    /* Sticky buy bar on phones */
    var sticky = $('[data-sticky-buy]', root);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', function () { addBtn.click(); });
    }
  });

  /* Related products (Shopify recommendations API) */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = $('[data-recs]', tmp);
      if (inner && inner.innerHTML.trim().length) {
        el.innerHTML = inner.innerHTML;
        $$('[data-reveal]', el).forEach(function (n) { n.classList.add('is-in'); });
      }
    });
  });
})();
